// extracted by mini-css-extract-plugin
export const link = "text-content-module--link--dO0Tv";
export const text = "text-content-module--text--D3XCP";
export const onlyText = "text-content-module--onlyText--FCgLN";
export const cardFlexStart5rem = "text-content-module--cardFlexStart5rem--HGh8G";